module.exports = __webpack_public_path__ + "static/fonts/fontawesome-webfont.e6cf7c6.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.woff2?v=4.6.3
// module id = 780
// module chunks = 2